module.exports = __webpack_public_path__ + "static/assets/3b9967509a673527658765ba7838c7dd.png";